<!--//////////////////////////
to do: Make this emit the same thing as VFileUpload: file, name, url
///////////////////////////////-->
<template>
  <form
    class="upload-box"
    enctype="multipart/form-data"
    :class="boxClass"
    :style="boxStyle"
    @dragenter.prevent="dragEnter($event)"
    @dragleave.prevent="dragLeave($event)"
    @dragover.prevent="dragOver($event)"
    @drop.prevent="drop($event)">

    <div class="upload-box__input" v-if="!uploaded">
      <input
        :key="fileName"
        class="upload-box__file"
        :disabled="disabled"
        type="file"
        name="files[]"
        :id="id"
        @input="changedFile($event)"
        :required="required"/>
      <label :for="id">
        <div
          class="text--wrap"
          v-if="!value">
          <div class="has-text-weight-bold">Choose a file</div>
          <span v-if="hasAdvancedUpload"> or drag it here</span>.
        </div>
        <div v-else>
          <div class="has-text-weight-bold">{{ fileName }}</div> selected
        </div>
      </label>
    </div>

    <!-- <v-fade-transition mode="out-in">
      <v-btn
        v-if="files && !immediate && !uploaded"
        round
        class="primary mt-4"
        @click.stop="submit"
        :loading="uploading">
        Upload this file
      </v-btn>

      <div class="centered" v-if="uploaded">
        <v-checkmark/>
        <div class="mt-3">
          Upload successful!
        </div>
      </div>
    </v-fade-transition>
    <div class="upload-box__uploading">Uploading&hellip;</div>
    <div class="upload-box__success">Done!</div>
    <div class="upload-box__error">Error! <span></span>.</div> -->
  </form>
</template>

<script>
import validatable from '@/mixins/validatable'

export default {
  mounted() {
    this.checkAdvancedUpload();
  },
  props: {
    id: {
      type: [String, Number]
    },
    value: {
      default: null
    },
    fileName: {
      type: String,
      default: null
    },
    height: {
      type: String,
      default: '300px'
    },
    required: {
      type: Boolean
    },
    maxSize: {
      default: 24576,
      type: Number
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  mixins: [validatable],
  data() {
    return {
      isDragover: false,
      hasAdvancedUpload: false,
      uploading: false,
      uploaded: false
    }
  },
  computed: {
    boxClass() {
      return {
        'is-dragover': this.isDragover,
        'has-advanced-upload': this.hasAdvancedUpload,
        'is-disabled': this.disabled
      }
    },
    boxStyle() {
      return {
        'height': this.height
      }
    },
    maxMbs() {
      return this.maxSize / 1024;
    }
  },
  methods: {
    checkAdvancedUpload() {
      var div = document.createElement('div');
      this.hasAdvancedUpload = (('draggable' in div) ||
              ('ondragstart' in div && 'ondrop' in div)) &&
              'FormData' in window && 'FileReader' in window;
    },
    dragEnter() {
      this.isDragover = true;
    },
    dragOver() {
      this.isDragover = true;
    },
    dragLeave() {
      this.isDragover = false;
    },
    dragEnd() {
      this.isDragover = false;
    },
    drop(e) {
      this.isDragover = false;
      let file = e.dataTransfer.files[0];
      if (file) {
        if (this.fileSizeValidator(file)) {
          this.$emit('input', file);
          this.$emit('update:fileName', file.name)
          this.validate(file);
        } else {
          alert(`Your file is too big! Please select an image under ${this.maxMbs} MBs`);
        }
      }
    },
    changedFile(e) {
      let file = e.target.files[0];
      if (this.fileSizeValidator(file)) {
        this.$emit('input', file);
        this.$emit('update:fileName', file.name);
        this.validate(file);
      } else {
        alert(`Your file is too big! Please select an image under ${this.maxMbs} MBs`);
      }
    },
    fileSizeValidator(file) {
      const { maxSize } = this;
      let size = file.size / maxSize / maxSize;
      return size < 1;
    }
  }
}
</script>

<style lang="scss" scoped>

.centered {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.upload-box__dragndrop,
.upload-box__uploading,
.upload-box__success,
.upload-box__error,
.upload-box__file {
  display: none;
}

.upload-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:not(.is-disabled) {
    &.has-advanced-upload {
      background-color: whitesmoke;
      outline: 2px dashed lightgray;
      outline-offset: -10px;
    }
    &.is-dragover {
      outline: 2px dashed gray;
      background-color: silver;
    }
    label {
      cursor: pointer;
    }
  }

  &.is-disabled {
    cursor: not-allowed;
    &.has-advanced-upload {
      background-color: whitesmoke;
    }
    label {
      color: gray !important;
    }
    label {
      cursor: not-allowed;
    }
  }

  &__input {
    padding: 15px;
  }

}
</style>
